const suffixes = ['', 'K', 'M', 'B', 'T'];
window.formatAxisNumber = function (value) {
    let newValue = value;
    let suffixNum = 0;
    while (newValue >= 1000) {
        newValue /= 1000;
        suffixNum++;
    }
    newValue = newValue.toPrecision(3);
    newValue += suffixes[suffixNum];
    return newValue;
};

const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
window.formatFileSizeNumber = function (number) {
    let tier = Math.log10(Math.abs(number)) / 3 | 0;
    if (tier === 0) {
        return number;
    }
    
    return (number / Math.pow(10, tier * 3)).toFixed(1) + SI_SYMBOL[tier];
};

window.set = function (object, path, value) {
    const [head, ...rest] = path.split('.');
    if (rest.length === 0) {
        object[head] = value;
    } else {
        if (object[head] === undefined) {
            object[head] = {};
        }
        set(object[head], rest.join('.'), value);
    }
};

window.trans = function (translations) {
    let lang = document.documentElement.lang;
    let keys = Object.keys(translations);
    
    if (typeof translations !== 'object' || keys.length === 0) {
        return `-- Error: Translation not found [lang: ${lang}] --`;
    }
    
    if (lang in translations) {
        return translations[lang];
    }
    
    return translations[keys[0]];
};

window.strSlug = function (title, separator) {
    if (typeof separator == 'undefined') separator = '-';
    
    // Convert all dashes/underscores into separator
    var flip = separator == '-' ? '_' : '-';
    title = title.replace(flip, separator);
    
    // Remove all characters that are not the separator, letters, numbers, or whitespace.
    title = title.toLowerCase()
        .replace(new RegExp('[^a-z0-9' + separator + '\\s]', 'g'), '');
    
    // Replace all separator characters and whitespace by a single separator
    title = title.replace(new RegExp('[' + separator + '\\s]+', 'g'), separator);
    
    return title.replace(new RegExp('^[' + separator + '\\s]+|[' + separator + '\\s]+$', 'g'), '');
};

if (document.getElementById('page-register-account')) {
    document.querySelectorAll('.register-check-accountname').forEach(item => {
        item.addEventListener('change', function (event) {
            var changeOn = document.getElementById('accountname');
            var changeTextFrom = document.getElementById('company');
            
            if (event.target.id === 'accountname') {
                changeTextFrom = changeOn;
            }
            
            var slugString = strSlug(changeTextFrom.value);
            
            changeOn.value = slugString.length < 30 ? slugString : slugString.substring(0, 30);
        });
    });
    
    document.getElementById('register-page-accountname').addEventListener('click', function (event) {
        if (event.target.id == 'accountname') {
            event.target.disabled = false;
        }
    });
    
    document.getElementById('page-register-account').addEventListener('submit', function (event) {
        event.preventDefault();
        document.getElementById('accountname').disabled = false;
        event.target.submit();
    });
}
